import { useEffect, useRef } from "react";
import { Style, Fill, Stroke } from "ol/style";
import { nfdrs_risk_colors_alpha, risk_ids } from "./nfdrs_colors";

export const useFDRAColors = (mapRef, colorInfo) => {
  const colorMappingRef = useRef({});
  const styleCacheRef = useRef({});

  // Initialize mapping once
  useEffect(() => {
    colorMappingRef.current = {
      "Lake Ontario Plains": "",
      "St. Lawrence": "",
      "Upper Hudson Champlain": "",
      "Hudson Valley": "",
      "Catskill": "",
      "Long Island": "",
      "Leatherstocking": "",
      "Southern Tier": "",
      "Adirondack": "",
      "Adirondack High Peaks": "",
      "New York": "",
      "Bronx": "",
    };
  }, []);

  useEffect(() => {
    if (!mapRef.current || !colorInfo) return;

    Object.assign(colorMappingRef.current, colorInfo);

    const map = mapRef.current;

    const getColorForFDRA = (fdraName) => {
      const risk = colorMappingRef.current[fdraName];
      const riskName = risk_ids[risk];
      return nfdrs_risk_colors_alpha[riskName] || "rgba(255,255,255,0.2)";
    };

    const fdraStyle = (feature) => {
      const name = feature.get("Name");

      if (!name) return null;

      // cache key per region + risk value
      const risk = colorMappingRef.current[name];
      const cacheKey = `${name}-${risk}`;

      if (!styleCacheRef.current[cacheKey]) {
        const fillColor = getColorForFDRA(name);

        styleCacheRef.current[cacheKey] = new Style({
          fill: new Fill({
            color: fillColor,
          }),
          stroke: new Stroke({
            color: "#d3e8ff",
            width: 2,
          }),
        });
      }

      return styleCacheRef.current[cacheKey];
    };
    const applyStyleToLayers = (layers) => {
        layers.forEach((layer) => {
            // recurse into groups
            if (layer.getLayers) {
                applyStyleToLayers(layer.getLayers().getArray());
                return;
            }
            if (layer.get("layerType") === "fdra") {

                layer.setStyle(fdraStyle);

                layer.getSource()?.changed();
                layer.changed();
            }
        });
    };

    applyStyleToLayers(map.getLayers().getArray());

  }, [colorInfo, mapRef]);
};